export enum GregorioVPosition {
  AUTO = 0,
  BELOW = -1,
  ABOVE = 1,
}
